client import { EditorEngine } from "./editor-engine";
import * as styles from "./editor.styles.module.scss";
export interface Input {
  value: string;
  valueChange: (value: string) => void;
  lineClasses: Map<number, string>;
  onLineHover?: (line: number) => void;
}

div class=styles.editor
  div/$gutter class=styles.gutter
  div/$editable
    ,class=styles.editable
    ,contenteditable="true"
    ,role="textbox"
    ,aria-label="Source editor"
    ,aria-multiline="true"
    ,spellcheck=false
    ,autocapitalize="off"
    ,data-gramm="false"

lifecycle<{ engine?: EditorEngine; change?: boolean; set(v: string): void }>
  ,set(content) {
    this.change = content !== input.value;
    if (this.change) {
      input.valueChange(content);
    }
  }
  ,onMount() {
    this.change = false;
    this.engine = new EditorEngine(
      $editable(),
      $gutter(),
      (value) => this.set(value),
      input.onLineHover,
    );
    this.engine.setValue(input.value);
    this.engine.applyLineClasses(input.lineClasses);
  }
  ,onUpdate() {
    if (this.change) {
      this.change = false;
    } else {
      this.engine!.setValue(input.value);
    }
    this.engine!.applyLineClasses(input.lineClasses);
    this.engine!.updateFolding();
    this.engine!.highlightActiveLine();
  }
  ,onDestroy() {
    this.engine!.destroy();
  }
